import React, { useState } from 'react';
import { capitalize } from 'lodash';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';

import logo from '../../../assets/images/logo-ghs-full-width.svg';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import LinkItem from './LinkItem';
import { sideBarLinks } from './sidebar-links';
import {
  Root,
  Logo,
  LinksGroupTitle,
  Links,
  StyledChevronIcon,
  UserName,
  UserMenu,
  MenuItem,
  MenuLabel,
  User,
} from './styles';

const SideBar = () => {
  const { pathname: currentPath } = useLocation();
  const {
    currentUser: {
      data: { first_name: firstName, last_name: lastName },
    },
  } = useAuth();
  const history = useHistory();

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('token_expiration');
    history.go(0);
  };

  return (
    <Root>
      <Logo src={logo} alt="GHS Logo" />

      <Links>
        {sideBarLinks.map(({ groupTitle, links }) => (
          <React.Fragment key={groupTitle}>
            <LinksGroupTitle>{groupTitle.toUpperCase()}</LinksGroupTitle>
            {links.map(({ label, pathname, icon }) => (
              <LinkItem
                key={label}
                label={label}
                icon={icon}
                pathname={pathname}
                active={currentPath === pathname}
              />
            ))}
          </React.Fragment>
        ))}
      </Links>

      <User
        onClick={toggleMenu}
        menuOpen={menuOpen}
        className={menuOpen && 'active'}
      >
        <AccountCircleIcon />
        <UserName>
          {capitalize(firstName)} {capitalize(lastName)}
        </UserName>
        <StyledChevronIcon />

        {menuOpen && (
          <ClickAwayListener onClickAway={toggleMenu}>
            <UserMenu>
              {/* <MenuItem>
                <PersonOutlineOutlinedIcon />
                <MenuLabel>Account</MenuLabel>
              </MenuItem> */}

              <MenuItem onClick={logout}>
                <ExitToAppOutlinedIcon />
                <MenuLabel>Log Out</MenuLabel>
              </MenuItem>
            </UserMenu>
          </ClickAwayListener>
        )}
      </User>
    </Root>
  );
};

export default SideBar;
